import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  FormControlLabel, Radio, RadioGroup, makeStyles,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FaChevronDown } from 'react-icons/fa';
import { useAnalytics } from 'use-analytics';
import AddCardForm from '../../../../../CruiseBooking/PaymentConfig/AddCardForm';
import SavedCards from '../../../../../CruiseBooking/PaymentConfig/SavedCards';
import { changeTrip, doUseSavedCardForCheckout } from '../../../../../../store/slices/trip';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '0.75rem',
  },
}));
const useStylesRadioGroup = makeStyles(() => ({
  root: {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'var(--fontFamilyBody)',
    },
  },
}));

const CardSelectForm = ({ tripId, doShowCardForm, onCardFormShown }) => {
  const { track } = useAnalytics();
  const classes = useStyles();
  const classesRadioGroup = useStylesRadioGroup();
  const dispatch = useDispatch();
  const doUseSavedCard = useSelector(doUseSavedCardForCheckout);
  const { travelAgency, email: loggedInUserEmail } = useSelector((store) => store.user);

  const handleChangeCardSelection = (event) => {
    dispatch(changeTrip({
      field: 'doUseSavedCard',
      value: event.target.value === 'true',
    }));
    track('PaymentConfig.doUseSavedCard', { doUseSavedCard: event.target.value === 'true', tripId, loggedInUserEmail });
  };

  const handleShowCardForm = () => {
    if (onCardFormShown) {
      onCardFormShown(!doShowCardForm);
    }
  };

  return (
    <div className="text-xs">
      {!doShowCardForm && (
      <>
        <button type="button" className="mt-2 underline text-theme ml-1" onClick={handleShowCardForm}>
          Select credit card
          <FaChevronDown className="inline-block ml-1" />
        </button>
        <div className="text-gray-600 ml-1">
          If you do not select a card, the default credit card from
          {' '}
          {travelAgency.sabreProfileName}
          {' '}
          profile will be utilized for the booking.
        </div>
      </>
      )}
      {doShowCardForm && (
      <div className={clsx({ 'border border-gray-400 rounded p-2 mt-2': doShowCardForm })}>
        <div>
          <div className="w-95 mx-auto">
            <div className="font-bold">Credit card</div>
            <div className="text-grey-700">Select credit card to use for booking trip quote. MasterCard, Visa, Amex, Diners Club, JCB, Discover</div>
            <RadioGroup
              aria-label="changeCardSelection"
              name="changeCardSelection"
              classes={classesRadioGroup}
              value={(doUseSavedCard || false).toString()}
              onChange={handleChangeCardSelection}
              row
            >
              <FormControlLabel value="false" classes={classes} control={<Radio />} label="New card" />
              <FormControlLabel classes={classes} value="true" control={<Radio />} label="Saved cards" />
            </RadioGroup>

            {!doUseSavedCard ? (
              <AddCardForm
                cardIndex={0}
                doShowSecurityCodeInput={false}
                doTakeCardAddressInputs={false}
                widthClass=""
                inputLayout={AddCardForm.InputLayoutTypes.ROW}
              />
            ) : (
              <SavedCards tripId={tripId} />
            )}
            <div className="text-right">
              <button type="button" onClick={handleShowCardForm}>Don&apos;t include card</button>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

CardSelectForm.propTypes = {
  tripId: PropTypes.string.isRequired,
  doShowCardForm: PropTypes.bool.isRequired,
  onCardFormShown: PropTypes.func,
};

CardSelectForm.defaultProps = {
  onCardFormShown: undefined,
};
export default CardSelectForm;
